import { CommonModule, TitleCasePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { QuillModule } from 'ngx-quill';
import { ApiService } from '../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { CapitalizePipe } from '../capitalize.pipe';
import { LanguageService } from '../language.service';
import { maxPlainTextLength } from '../shared/plainTextLengthValidator';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-signature-form',
  imports: [ReactiveFormsModule, QuillModule, FormsModule, CommonModule, CapitalizePipe],
  templateUrl: './signature-form.component.html',
  styleUrls: ['./signature-form.component.css'],
  providers: [TitleCasePipe, CapitalizePipe]
})
export class SignatureFormComponent {
  captalizePipe = inject(CapitalizePipe)
  editorModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      // ['link', 'image', 'video', 'formula'],
      ['link'],
      ['script', 'sub', 'super'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'align': [] }],
      [{ 'header': [1, 2, 3, false] }],
      [{ 'color': [] }, { 'background': [] }],
      ['clean']
    ]
  };

  BE_BRANDS = ["Duro-Last","BMQ","BMQ Solutions","Gaco", "Enverge","Gaco and Enverge","Plastatech","TIP-TOP","Protect-All","Exceptional Metals","American Safety Technologies (AST)","Tacky Tape"];
  // BE_BRANDS = ["Duro-Last","Elevate","Genflex","OX","Malarkey","Gaco","Enverge","Tacky Tape","American Safety (AST)","BMQ","BMQ Solutions"];

  countries = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "East Timor",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea, North",
    "Korea, South",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "North Macedonia",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines", "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe"];

  signatureForm!: FormGroup;
  submitted = false;
  editorContent = 'none';
  urls: any;
  banners: any;
  promotionalBanners: any;
  modules: any;
  preview: boolean = false;
  userData: any;
  token!: string;
  filteredCountries: string[] = [];
  emailSignData: any;
  companiesName: any;
  brandsList: any;
  amrizeStripeFrench = environment.amrizeStripeFrenchBE;
  amrizeStripeEnglish = environment.amrizeStripeEnglishBE;


  safeTikTokUrl?: SafeUrl;
  
  constructor(private formBuilder: FormBuilder, private oauthService: OAuthService, private apiService: ApiService,private sanitizer: DomSanitizer,
    private router: Router, private route: ActivatedRoute, public languageService: LanguageService) { }

  ngOnInit(): void {
    this.initalizeForm();
    this.getUrls();
    this.getCompanyName();
    this.getBrandsInfo();
    this.userData = this.oauthService.getIdentityClaims();
    this.token = this.oauthService.getAccessToken();
    this.signatureForm.get('country')?.valueChanges.subscribe(value => {
      this.filteredCountries = this.filterItems(value);
    });
    this.signatureForm.get('marketBrand')?.valueChanges.subscribe(marketBrand => {
    const tiktokUrl = marketBrand?.tiktok;
    this.safeTikTokUrl = tiktokUrl ? this.sanitizer.bypassSecurityTrustUrl(tiktokUrl) : undefined;
  });
    this.getEmailSignDetails();
    this.setData();
  }

  initalizeForm() {
    this.signatureForm = this.formBuilder.group({
      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      function: [''],
      division: [''],
      title: ['', [Validators.required]],
      legalCompany: [''],
      address: ['', []],
      postcode: ['', []],
      city: ['', []],
      country: ['', []],
      phone: ['', []],
      mobile: ['', []],
      fax: [''],
      newemail: ['', [Validators.required, Validators.email]],
      additionalInfo: ['', [maxPlainTextLength(1000)]],
      url: ['', [Validators.required]],
      banner: ['https://storage.googleapis.com/esign-dev-bkt/branding/Amrize_tagline_h_rgb.png'],
      marketBrand: [''],
      promotionalBanner: [''],
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.signatureForm.valid) {
      this.preview = true;
    };
    console.log(this.signatureForm.value);
  }

  getCompanyName() {
    this.apiService.getCompanies().subscribe({
      next: (res) => {
        this.companiesName = res;
      },
      error: (err: Error) => {
        console.error('Error fetching Companies:', err);
      }
    });
  };

  getUrls() {
    this.apiService.getUrls().subscribe({
      next: (res) => {
        this.urls = res;
      },
      error: (err: Error) => {
        console.error('Error fetching URLs:', err);
      }
    });
  };

  getBanners() {
    this.apiService.getBanners().subscribe({
      next: (res: any) => {
        this.banners = Object.keys(res).map((ele: any) => ({ key: ele, value: res[ele] }));
      },
      error: (err: Error) => {
        console.error('Error fetching URLs:', err);

      }
    });
  };

  getMarketBrands() {
    this.apiService.getBrands().subscribe({
      next: (res: any) => {
        console.log('response brands::::', res);
        this.brandsList = Object.keys(res).map((ele: any) => ({ key: ele, value: res[ele] }));
        // this.brandsList = Object.keys(res).map((ele: any) => {
        //   const value = res[ele];
        //   const parsedValue = (value.includes(',')) ? value.split(',').map((v: string) => v.trim()) : value;
        //   return { key: ele, value: parsedValue };
        // });
        console.log('this.brandsList::::', this.brandsList);
      },
      error: (err: Error) => {
        console.error('Error fetching URLs:', err);

      }
    });
  };

  getBrandsInfo() {
    this.apiService.getBrandsInfo().subscribe({
      next: (res: any) => {
        console.log('brandinfo:::', res);
        this.brandsList = res;
      },
      error: (err: Error) => {
        console.error('Error fetching URLs:', err);

      }
    });
  }

  // getPromotionalBanners() {
  //   this.apiService.getPromotionalbanners().subscribe({
  //     next: (res: any) => {
  //       this.promotionalBanners = Object.keys(res).map((ele: any) => ({ key: ele, value: res[ele] }));
  //     },
  //     error: (err: Error) => {
  //       console.error('Error fetching URLs:', err);

  //     }
  //   });
  // };

  setData() {
    this.signatureForm.get('firstname')?.setValue(this.emailSignData?.fname || this.userData?.given_name);
    this.signatureForm.get('lastname')?.setValue(this.emailSignData?.lname || this.userData?.family_name);
    this.signatureForm.get('newemail')?.setValue(this.emailSignData?.email || this.userData?.email);
    this.signatureForm.get('additionalInfo')?.setValue(this.emailSignData?.misc);
    this.signatureForm.get('banner')?.setValue(this.emailSignData?.member || 'https://storage.googleapis.com/esign-dev-bkt/branding/Amrize_tagline_h_rgb.png');
    this.signatureForm.get('legalCompany')?.setValue(this.emailSignData?.comName);
    this.signatureForm.get('marketBrand')?.setValue(this.emailSignData?.marketBrandLogo);
    this.signatureForm.patchValue(this.emailSignData);
  }

  compareBrands(brand1: any, brand2: any): boolean {
    return brand1 && brand2 ? brand1.brandName === brand2.brandName : brand1 === brand2;
  }

  submitFinalSignature() {
    console.log("this.languageService.languageConfig>>>>>",this.languageService.languageConfig)
    const payload = {
      address: this.signatureForm.value?.address,
      postcode: this.signatureForm.value?.postcode,
      city: this.signatureForm.value?.city,
      comName: this.signatureForm.value?.legalCompany,
      country: this.signatureForm.value?.country,
      division: this.signatureForm.value?.division,
      email: this.signatureForm.value?.newemail,
      fax: this.signatureForm.value?.fax,
      fname: this.signatureForm.value?.firstname,
      function: this.signatureForm.value?.function,
      lname: this.signatureForm.value?.lastname,
      mobile: this.signatureForm.value?.mobile,
      title: this.captalizePipe.transform(this.signatureForm.value?.title),
      url: this.signatureForm.value?.url,
      phone: this.signatureForm.value?.phone,
      promotionalBanner: this.signatureForm.value?.promotionalBanner,
      csrf_token: this.token,
      misc: this.signatureForm.value?.additionalInfo || '',
      member: this.signatureForm.value?.banner,
      marketBrandLogo: this.signatureForm.value?.marketBrand || null,
      desclaimer: this.languageService.languageConfig?.email_signature_disclaimer,
      brandTagline: this.signatureForm.value?.marketBrand?.brandName + this.languageService.languageConfig?.brandTagline,
      amrizeStripeLang: this.languageService.language === "English" ? this.amrizeStripeEnglish : this.amrizeStripeFrench
    }
    this.apiService.setSignature(payload).subscribe({
      next: (res) => {
        this.router.navigate(['/genemail'], { queryParams: { success: true } })
      },
      error: (err) => {
        console.error('Error submitting signature:', err);
        this.router.navigate(['/genemail'], { queryParams: { error: true } })
      }
    });
  };



  onInputChange(): void {
    const value = this.signatureForm.get('country')?.value;
    this.filteredCountries = this.filterItems(value);
  }

  filterItems(inputVal: string) {
    if (!inputVal) return [];
    return this.countries.filter(country => country.toLowerCase().includes(inputVal.toLowerCase()));
  }

  selectCountry(item: string): void {
    this.signatureForm.get('country')?.setValue(item);
    this.filteredCountries = [];
  }

  getEmailSignDetails() {
    const email = this.userData?.email
    this.apiService.getEmailSignature(email).subscribe({
      next: (res) => {
        this.emailSignData = res
        console.log('emailData::::::::', res)
        this.setData();
      },
      error: (err) => {
        console.error('getEmailSignDetails Error', err);
      }
    });
  }

  combineBanner(value: string) {
    const parsedValue = (value.includes(',')) ? value.split(',').map((v: string) => v.trim()) : value;
    console.log('parsedValue::::::::', parsedValue)
    return parsedValue
  }


}
